const toggleForm = () => {
  const formToggleButtons = document.querySelectorAll('a.form-toggle-button');

  if (!formToggleButtons || Array.from(formToggleButtons).length < 1) return;

  formToggleButtons.forEach(formToggleButton => {
    const formId = formToggleButton.dataset.form;

    if (!formId) return;

    const form = document.querySelector(`.form-container#${formId}`);

    if (!form) return;

    form.querySelector('.form-close-button').addEventListener('click', function() {
      form.classList.toggle('active');
      document.body.classList.remove('form-active');
    });

    formToggleButton.addEventListener('click', function(e) {
      e.preventDefault();

      form.classList.toggle('active');
      document.body.classList.add('form-active');
    });
  });
}

$(document).ready(toggleForm);

const toggleFullAgreementText = () => {
  const fullAgreementTextToggles = document.querySelectorAll('.show-more-text-toggle');

  if (!fullAgreementTextToggles || Array.from(fullAgreementTextToggles).length < 1) return;

  fullAgreementTextToggles.forEach(fullAgreementTextToggle => {
    fullAgreementTextToggle.addEventListener('click', function() {
      const agreement = fullAgreementTextToggle.closest('.row--form').querySelector('.form-rule p');

      if (!agreement) return;

      agreement.classList.toggle('showing-more-text');
      
      fullAgreementTextToggle.innerText = `${fullAgreementTextToggle.dataset.showingMore == 'true' ? fullAgreementTextToggle.dataset.showMoreText : fullAgreementTextToggle.dataset.showLessText}`;
      fullAgreementTextToggle.setAttribute('data-showing-more', fullAgreementTextToggle.dataset.showingMore == 'true' ? 'false' : 'true');
    });
  });
}

$(document).ready(toggleFullAgreementText);

const toggleFullClauseText = () => {
  const fullClauseTextToggles = document.querySelectorAll('.full-clause-toggle');

  if (!fullClauseTextToggles || Array.from(fullClauseTextToggles).length < 1) return;

  fullClauseTextToggles.forEach(fullClauseTextToggle => {
    fullClauseTextToggle.addEventListener('click', function() {
      const clause = fullClauseTextToggle.closest('.row--form').querySelector('.form-rule--hidden');

      if (!clause) return;

      clause.classList.toggle('active');
    });
  });
}

$(document).ready(toggleFullClauseText);